import { Injectable } from '@angular/core';
import { UserService } from './user.services';

@Injectable({ providedIn: 'root' })
export class AdminProfileCompletionService {
  constructor(private userService: UserService) {}

  get requireAdminProfileCompletion(): boolean {
    const creds = this.userService.currentUserCredantials;
    return !!creds?.requireAdminProfileCompletion;
  }

  markProfileCompleted(): void {
    this.setProfileCompletedInStorage();
  }

  private setProfileCompletedInStorage(): void {
    try {
      const currentUser = this.userService.currentUserCredantials;
      if (currentUser) {
        const updated = { ...currentUser, requireAdminProfileCompletion: false };
        this.userService.currentUserCredantials = updated;
      }
    } catch (e) {
      console.warn('Could not update currentUser after profile completion', e);
    }
  }
}
